import { cardsData, updatesData, commentsData } from '@/mocks/homeData';

export function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-fire-line text-primary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">热门爆料</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">最新、最热的黑料爆料，实时追踪事件进展</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {cardsData.map((card) => (
              <article key={card.id} className="group rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 overflow-hidden cursor-pointer flex flex-col">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                      {card.category}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-1 text-xs font-semibold bg-background-50/90 text-primary-600 rounded-md whitespace-nowrap">
                      {card.heat}热度
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5 flex-1 flex flex-col">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-3 flex-1">
                    {card.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{card.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {card.heat}阅读
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-timer-flash-line text-accent-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">实时快讯</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">7×24小时滚动更新，最新爆料一手掌握</p>

          <div className="space-y-0">
            {updatesData.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-start gap-3 md:gap-4 py-3 md:py-3.5 ${
                  idx < updatesData.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div className="flex items-center gap-2 shrink-0 w-20 md:w-24">
                  <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.time}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                </div>
                <div className="flex-1 min-w-0 flex items-center gap-2">
                  <p className="text-sm text-foreground-700 leading-snug">{item.title}</p>
                  {item.tag && (
                    <span className={`shrink-0 px-1.5 py-0.5 text-xs font-semibold rounded whitespace-nowrap ${
                      item.tag === '爆' || item.tag === '最新'
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-accent-500 text-background-50'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100">
              <i className="ri-chat-3-line text-secondary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">读者热评</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">全网吃瓜群众的真实声音</p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {commentsData.map((comment) => (
              <div key={comment.id} className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                    <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.time}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line text-primary-500"></i>
                  <span className="font-medium">{comment.likes.toLocaleString()}</span>
                  <span className="ml-auto cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-reply-line"></i> 回复
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}